import {v4 as uuidv4} from 'uuid'
import {ImgText} from '../../models/editor/imgText'
import {origo} from './origo'

export const createPrintArea = (
  printWidthMm: number,
  printHeightMm: number,
  color: string = 'black',
): ImgText => ({
  id: uuidv4(),
  type: 'text',
  text: `<svg width="${printWidthMm}mm" height="${printHeightMm}mm" viewBox="0 0 ${printWidthMm}mm ${printHeightMm}mm">
       <rect width="${printWidthMm}mm" height="${printHeightMm}mm" style="fill:transparent;stroke-width:4;stroke:${color}" stroke-dasharray="5,5" vector-effect: non-scaling-stroke; />
       </svg>`,
  brightness: 1,
  filters: {inverse: false, monochrome: false, sepia: false},
  inert: true,
  locked: true,
  mirroredX: false,
  mirroredY: false,
  position: origo,
  rotation: 0,
  scale: 1,
})
